
import Header from '../../Component/Header';
import Popup from '../../Component/Popup';
import "../../styles/scope.css";
import Vector from "../../assets/svg/editIcon.svg";
import Delete from "../../assets/svg/DeleteIcon.svg";
import { useState, useRef, useEffect } from "react";
import DatePicker from "../../Component/DatePicker"
import ReactPaginate from "react-paginate";
import SubCategoryPopup from '../SubCategory/SubCategoryPopup'
import CommonFooter from '../../CommonFooter/CommonFooter';

const SubCategoryGrid = () => {
  const [tableData, setTableData] = useState([]);
  const [error, setError] = useState(null);
  const [limit, setLimit] = useState(5);
  const [currentPage, setCurrentPage] = useState(0);
  const [skip, setSkip] = useState(0);
  const [total, setTotal] = useState(0);
  const [totalPages, setTotalPages] = useState(0);
  const [isPopupOpen, setIsPopupOpen] = useState(false);
  const [selectedRows, setSelectedRows] = useState([]);
  const popupRef = useRef(null);
  const [editData, setEditData] = useState(null);

  const token = "eyJ0eXAiOiJKV1QiLCJhbGciOiJIUzI1NiJ9.eyJpc3MiOiJodHRwczovL2FwaS11YXQubWF3YWxvZy5jb20vYWRtaW4vdjIvYXBpL2xvZ2luIiwiaWF0IjoxNzQ4MjQzMjM3LCJleHAiOjE3NjM3OTUyMzcsIm5iZiI6MTc0ODI0MzIzNywianRpIjoicEZiZlY0N3RtR3hIT1lLNCIsInN1YiI6IjQyMSIsInBydiI6IjlhZDU4NTc3ZmFiNmZiYzE1NTQzNGQzNTkxZWRmMTY0YTE3NzY1YWEiLCJhdXRoaWQiOjQyMSwib3JnaWQiOjEwMCwidXNlcmlkIjo0MjEsImRhdGFiYXNlbmFtZSI6InJhZ3VyciIsIm9yZ19jb2RlIjoicmFndXJyIiwidGltZXpvbmUiOiIgKyBpbnRlcnZhbCAnMDUgaG91cnMgMzAgbWludXRlcyciLCJyb2xlaWQiOjQwMSwicGF5bWVudF9zdGF0dXMiOnRydWUsImF1dGhvcml0aWVzIjpbIlJPTEVfVVNFUiJdfQ.W1Zci5YGI82pHEG8yyv1bBgC95okfRbQpn0iSYmzQig";


  useEffect(() => {


    fetch(`https://api-uat.mawalog.com/cost_design/v1/api/costsolution/subcategory?limit=${limit}&skip=${skip}`, {
      method: "GET",
      headers: {
        "Authorization": `Bearer ${token}`,
        "Content-Type": "application/json",
        "Accept": "application/json",
      },
    })
      .then((response) => {
        if (!response.ok) {
          throw new Error(`HTTP error! Status: ${response.status}`);
        }
        return response.json();
      })
      .then((data) => {
        if (Array.isArray(data.subcategory)) {
          setTableData(data.subcategory);
          setTotal(data.totalCount || 0);
          setTotalPages(Math.ceil((data.totalCount || 0) / limit));
        } else {
          setTableData([]);
        }
      })
      .catch((error) => {
        setError(error.message);
        console.error("There was a problem with the fetch operation:", error);
      });
  }, [skip, limit]);





  useEffect(() => {
    const handleClickOutside = (event) => {
      if (popupRef.current && !popupRef.current.contains(event.target)) {
        closePopup();
      }
    };
    if (isPopupOpen) {
      document.addEventListener("mousedown", handleClickOutside);
    }
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, [isPopupOpen]);

  const handlePageClick = ({ selected }) => {
    setCurrentPage(selected);
    setSkip(selected * limit);
  };

  const handleLimitChange = (e) => {
    const newLimit = Number(e.target.value);
    setLimit(newLimit);
    setCurrentPage(0);
    setSkip(0); // Reset skip when limit changes
  };


  const handleDateSelection = (date) => {
    console.log("Selected Date:", date);
  };

  const handleAddNewClick = (row) => {
    console.log("Editing row data:", row); // Debugging: Check what is passed
    setEditData({ id: row.id });
    setIsPopupOpen(true);
  };


  const closePopup = () => {
    setEditData(null);
    setIsPopupOpen(false);
  };


  const isAllSelected = selectedRows.length === tableData.length;
  const isAnySelected = selectedRows.length > 0;

  const handleSelectAll = () => {
    setSelectedRows(isAllSelected ? [] : tableData.map((row) => row.id));
  };

  const handleRowSelect = (id) => {
    setSelectedRows((prev) =>
      prev.includes(id) ? prev.filter((rowId) => rowId !== id) : [...prev, id]
    );
  };



  const handleDeleteRow = async (id) => {
    const confirmDelete = window.confirm("Are you sure you want to delete this item?");
    if (!confirmDelete) return;

    try {


      const response = await fetch(
        `https://api-uat.mawalog.com/cost_design/v1/api/costsolution/subcategory/delete/${id}`,
        {
          method: "DELETE",
          headers: {
            Authorization: `Bearer ${token}`,
            "Content-Type": "application/json",
          },
        }
      );

      if (response.ok) {
        alert("Row deleted successfully!");
        setTableData((prevData) => prevData.filter((row) => row.id !== id)); // ✅ Remove deleted row
        setTotal((prevTotal) => prevTotal - 1); // ✅ Update total count
      } else {
        const errorMessage = await response.text();
        alert(`Failed to delete the row! ${errorMessage}`);
      }
    } catch (error) {
      console.error("Error:", error);
      alert("Something went wrong while deleting!");
    }
  };


  return (
    <>
      <Header />
      <div className="container">
        <div className="header">
          <div className="left-header">
            <h3>All Sub category ({total})</h3>
          </div>
          <div className="right-header">
            {!isAnySelected ? (
              <>
                <DatePicker onDateChange={handleDateSelection} />

                <h4>Sort by :</h4>
                <div className="dropdown">
                  <select id="options" className="dropdown-select">
                    <option value="option1">Date Created</option>
                    <option value="option2">Option 2</option>
                    <option value="option3">Option 3</option>
                  </select>
                </div>
              </>
            ) : (
              <button id="deleteBtn" className="deleteBtn" onClick={handleDeleteRow}>
                Delete
              </button>
            )}
            {!isAnySelected && (
              <button id="addNewBtn" onClick={handleAddNewClick}>
                Add New
              </button>
            )}
          </div>
        </div>
        <table>
          <thead>
            <tr>
              <th style={{ width: "1px" }}>
                <input type="checkbox" checked={isAllSelected} onChange={handleSelectAll} />
              </th>
              <th>S.No</th>
              <th>Code</th>
              <th>Name</th>
              <th></th>
              <th>Category</th>
              <th>Date</th>
              <th></th>
            </tr>
          </thead>
          <tbody>
            {tableData.map((row, index) => (
              <tr key={row.id}>
                <td>
                  <input
                    type="checkbox"
                    checked={selectedRows.includes(row.id)}
                    onChange={() => handleRowSelect(row.id)}
                  />
                </td>
                <td>{skip + tableData.indexOf(row) + 1}</td>
                <td>{row.code}</td>
                <td>{row.name}</td>
                <td></td>
                <td>{row.category}</td>
                <td>{row.modifieddate}</td>
                <td>

                  <div className="actions">
                    <span className="edit-icon">
                      <img
                        src={Vector}
                        alt="Edit Icon"
                        width="20"
                        height="20"
                        onClick={() => handleAddNewClick(row)} // ✅ Passes row data correctly
                      />
                    </span>

                    <span
                      className="delete-icon"
                      onClick={() => handleDeleteRow(row.id)} // Ensure this matches the function name
                      style={{ cursor: "pointer" }}
                    >
                      <img src={Delete} alt="Delete Icon" width="40" height="40" />
                    </span>


                  </div>
                </td>
              </tr>
            ))}
          </tbody>
        </table>





        {/* Pagination Controls */}
        <div className="pagination-container d-flex align-items-center justify-content-between mt-3">

          {/* Limit Dropdown - Wrapped in d-flex to enable gap */}
          <div className="Limit-Dropdown">
            <label htmlFor="limit" className="fw-semibold">Items per page:</label>
            <select
              id="limit"
              value={limit}
              onChange={handleLimitChange}
              className="form-select d-inline w-auto"
            >
              <option value="5">5</option>
              <option value="10">10</option>
              <option value="15">15</option>
              <option value="20">20</option>
            </select>
          </div>


          {/* Pagination Component - Wrapped in d-flex to enable gap */}
          <div className="d-flex align-items-center gap-4">
            <ReactPaginate
              previousLabel={<span style={{ userSelect: "none" }}>Previous</span>}
              nextLabel={<span style={{ userSelect: "none" }}>Next</span>}
              pageCount={totalPages > 0 ? totalPages : 1}
              onPageChange={handlePageClick}
              containerClassName={"pagination d-flex"}
              activeClassName={"active"}
              marginPagesDisplayed={1}
              pageRangeDisplayed={3}
              forcePage={currentPage}
            />

          </div>

        </div>

      </div>

      <CommonFooter />

      {isPopupOpen && (
        <div className="popup-overlay">
          <div className="popup-content" ref={popupRef}>
            <SubCategoryPopup closePopup={closePopup} editData={editData} />
          </div>
        </div>
      )}
    </>
  );
};

export default SubCategoryGrid;


